import { render, staticRenderFns } from "./card_io_detail.vue?vue&type=template&id=10ae3c2a&scoped=true"
import script from "./card_io_detail.vue?vue&type=script&lang=js"
export * from "./card_io_detail.vue?vue&type=script&lang=js"
import style0 from "./card_io_detail.vue?vue&type=style&index=0&id=10ae3c2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ae3c2a",
  null
  
)

export default component.exports